import { render, staticRenderFns } from "./CertificationType.vue?vue&type=template&id=5947dfc1"
import script from "./CertificationType.vue?vue&type=script&lang=js"
export * from "./CertificationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports